import { render, staticRenderFns } from "./SwipeQuestion.vue?vue&type=template&id=5628bd86&scoped=true"
import script from "./SwipeQuestion.vue?vue&type=script&lang=js"
export * from "./SwipeQuestion.vue?vue&type=script&lang=js"
import style0 from "./SwipeQuestion.vue?vue&type=style&index=0&id=5628bd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628bd86",
  null
  
)

export default component.exports